export enum MasterMilestoneCalendarTypeEnum {
  PROJECT = 'PROJECT',
  PROJECT_CHECKLIST = 'PROJECT_CHECKLIST',
  HELPDESK = 'HELPDESK',
  DEAL_EVENT = 'DEAL_EVENT',
  TASK_PAYMENT = 'TASK_PAYMENT',
}
